import { render } from "./NewsCreateEdit.vue?vue&type=template&id=cc5f86e4&scoped=true"
import script from "./NewsCreateEdit.vue?vue&type=script&lang=js"
export * from "./NewsCreateEdit.vue?vue&type=script&lang=js"

import "./NewsCreateEdit.vue?vue&type=style&index=0&id=cc5f86e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc5f86e4"]])

export default __exports__